function getAesCbcOutputLength(inputByteLength) {
  var cipherTextLength = (Math.floor(inputByteLength / 16) + 1) * 16;
  return cipherTextLength;
}
function getBase64OutputLength(inputByteLength) {
  var encodedLength = Math.ceil(inputByteLength / 3) * 4;
  return encodedLength;
}
function hashCode(string) {
  var hash = 0;
  if (string.length === 0) return hash;

  for (var i = 0; i < string.length; i++) {
    var character = string.charCodeAt(i);
    hash = (hash << 5) - hash + character;
    hash &= hash;
  }

  return hash & 0x7fffffff;
}

export { getAesCbcOutputLength, getBase64OutputLength, hashCode };
//# sourceMappingURL=utils.esm.js.map
